exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-144047aa]{max-width:1280px;background-color:#fdfefe;padding:0 30px;width:100%;position:relative;margin:0 auto}@media screen and (max-width:64em){.layout[data-v-144047aa]{padding:0 15px}}.layout_header[data-v-144047aa]{position:-webkit-sticky;position:sticky;top:-65px;left:0;z-index:20;width:100%}@media screen and (max-width:64em){.layout_header[data-v-144047aa]{top:0}}.layout_header[data-v-144047aa]:after{content:\"\";display:block;position:fixed;top:0;left:0;right:0;z-index:-1;background:#fff;height:57px}.layout_header[data-v-144047aa]>:first-child{position:-webkit-sticky;position:sticky;top:0}.layout_header .layout_section[data-v-144047aa]{position:relative;z-index:-1}.layout_main[data-v-144047aa] .layout_section{margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-144047aa","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/AppDefaultLayout/AppDefaultLayout.vue
// module id = c3e415dbc1aac84071ab
// module chunks = 18